import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import logo from '../../assets/leo-logo.png';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100vw',
    minHeight: '100vh',
    background: theme.palette.background.default,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4), 
    boxSizing: 'border-box'
  },
  image: {
    width: '100%',
    maxWidth: 500
  },
}));

export const SplashScreen = ({ children }: any) => {
  const [loading, setLoading] = useState(true);
  const classes = useStyles();

  useEffect(() => {
    /*  simulate loading data */
    const timer = setTimeout(() => {
      setLoading(false);
      return () => {
        clearTimeout(timer);
      };
    }, 1000);
  }, []);
  if (loading) {
    return (
      <div className={classes.container}>
        <img src={logo} alt="logo" className={classes.image} />
      </div>
    );
  }

  return children;
};

export default SplashScreen;
